import axios from 'axios'

let options = {
  baseURL: process.env.API_DOMAIN
}

const httpClient = axios.create(options)
export { httpClient }